// Possibly move over the Searchbar stuff

// TODO: Remove Jquery
const SignupForm = {
    init: function(){
        this.delay = 20;
        this.setTimerStorage();
        this.attachCloseEvents();
        this.handleSubmit();
        this.bindEvents();
        this.pinToFooter();
    },
    setTimerStorage: function() {
        if (!sessionStorage.getItem('subscribe') && !sessionStorage.getItem('subscribe-close')) {
                timerStart = Date.now();
                totalTime = parseInt(sessionStorage.getItem('timeOnSite'));
                totalTime = isNaN(totalTime) ? 0 : totalTime;
                let timer = setInterval(function() {
                    timeOnSite = totalTime + parseInt((Date.now()-timerStart)/1000);
                    sessionStorage.setItem('timeOnSite', timeOnSite);
                    if (timeOnSite >= SignupForm.delay) {
                        clearInterval(timer);
                    }
                }, 1000);
        }
    },

	// TODO: Remove Jquery
    popUpLogicWithDelay: function() {
        let isMobile = $(window).width() < 576 || ($(window).height() < 576 && $(window).width() > 768) || $('body').hasClass('mobile');
        if (!sessionStorage.getItem('subscribe') && !sessionStorage.getItem('subscribe-close')) {
            if (getTimerStorage() >= SignupForm.delay || !isMobile) {
                return true;
            } else {
                return false;
            }
        }
    },

	// TODO: Remove Jquery
    attachCloseEvents: function() {
        $('.email-signup .close').click(function() {
            $('.email-signup.float').hide();
            $(this).hide();
            sessionStorage.setItem('subscribe-close','true');
        });
    },

	// TODO: Remove Jquery
    handleSubmit: function(){
          $('.email-signup form .form-submit-btn, .page-email-signup form .form-submit-btn, .signup form .form-submit-btn').on('click', function(e){
            e.preventDefault();
            let form = $(this).parents('form');
            if(_validateForm(form)) {
                sessionStorage.setItem('subscribe', 'true');
                form.submit();
            }
          });
    },

	// TODO: Remove Jquery
    bindEvents: function() {
        $("input#signup-email").focus(SignupForm.toggleSignupDisclaimer);
        $("input#signup-email").focusout(SignupForm.toggleSignupDisclaimer);
        $(window).scroll(SignupForm.pinToFooter);
    },

	// TODO: Remove Jquery
    toggleSignupDisclaimer: function() {
		if ($('.email-disclaimer').length) {
			$('.email-disclaimer').fadeToggle(200);
		}
    },

	// TODO: Remove Jquery
    pinToFooter: function() {
        if ($('.email-signup')[0]?.contains(document.activeElement)) return;
        if (SignupForm.popUpLogicWithDelay()) {
			let emailSignupHolder = $('.email-signup-holder')[0];
			if (emailSignupHolder) {
            	let rect = emailSignupHolder.getBoundingClientRect();
				if (rect) {
					if (rect.top >= 0 && rect.left >= 0 && rect.bottom - 300 <= $(window).height() && rect.right <= $(window).width() || rect.y < 0 ) {
						$('.email-signup.float').removeClass('float').addClass('pin').show();
						$('.email-signup .close').hide();
					} else {
						if ($('.email-signup').hasClass('pin')) {
							$('.email-signup.pin.allow-float').hide().removeClass('pin').addClass('float').fadeIn();
							$('.email-signup .close').show();
						} else {
							$('.email-signup.float').fadeIn();
						}

					}
				}
			}
        } else if (sessionStorage.getItem('subscribe') || sessionStorage.getItem('subscribe-close')) {
            $('.email-signup.float').removeClass('float allow-float').addClass('pin').show();
            $('.email-signup .close').hide();
        }
    }
}

function getTimerStorage() {
    return parseInt(sessionStorage.getItem('timeOnSite'));
  }

// TODO: Remove Jquery
function _validateForm(form){
  var valid = true;
  form.find('input,select,textarea,option').each(function(){
    if ($(this).closest('[aria-hidden="true"]').length) return;
    valid = _validateFormElement($(this));
    if (!valid) {
        return false;
    }
  });
  return valid;
}

// TODO: Remove Jquery
function _validateFormElement(formElem) {
    var valid = true;
    // checkbox, date, password, radio
    if(formElem.prop('required')) {
        switch(formElem.attr('type')) {
            case 'text':
                valid = formElem.val() != "" ? true : false ;
                if (valid == true && formElem.is("[name*='zip' i]")) {
                    if ($('body').hasClass('country-US')) {
                        var regex = new RegExp(/(^\d{5}$)|(^\d{5}-\d{4}$)/);
                        valid = regex.test(formElem.val()) ? true : false;
                    }
                }
            break;
            case 'email':
                var regex = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
                valid = regex.test(formElem.val()) ? true : false ;
                if (valid == true && formElem.is("[name*='confirm']")) {
                    valid = _confirmEmail(formElem);
                }
            break;
            case 'tel':
                var regex = new RegExp(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/);
                valid = regex.test(formElem.val()) ? true : false ;
            break;
            default:
                valid = formElem.val() != '' && formElem.val() != null ? true : false;
        }
        !valid ? formElem.addClass('error'):formElem.removeClass('error');
		
		// Find the closest .validationError element within the same parent container or its sibling
		var validationErrorElem = formElem.next('.validationError');
		if (!validationErrorElem.length) {
			validationErrorElem = formElem.parent().next('.validationError');
		}
		!valid && validationErrorElem.length ? validationErrorElem.show() : validationErrorElem.hide();
    }
    return valid;
}

// TODO: Remove Jquery
function _confirmEmail(formElem) {
    var emailInputs = $(formElem).closest('form').find("input[type='email']");
    if (emailInputs.length == 2 && ($(emailInputs[0]).val() == $(emailInputs[1]).val())) {
        return true;
    }
    return false;
}

// TODO: Remove Jquery
function submitForm(token, form, isRecaptcha = false) {
	let isAjaxForm = $(form).data('ajax') == true;
	if (token) {
		if(isAjaxForm === true) {
			submitFormViaAjax(form, isRecaptcha);
		} else {
			$(form).submit();
		}
	} else {
  	if(form.attr('name') == 'unsubscribeForm') {
			$(form).submit();
		}
	}
}

// TODO: Remove Jquery (ajax)
function submitFormViaAjax(form, isRecaptcha) {
	//Submit form via ajax
	const formAction = new URL($(form).attr('action')).search;
	const params = new URLSearchParams(formAction);
	const action = params.get('action');
	
	//Remove existing alert banners before proceeding
	const alertBanners = document.querySelectorAll('.alertBanner.submission-result');
	if(alertBanners.length > 0) [...alertBanners].forEach(banner => { banner.remove(); })
		
	//Get form data object
	const formData = isRecaptcha ? new FormData(form) : new FormData(form.get(0));

	//Ajax
	$.ajax({
		data: formData,
		type: 'POST',
		url: globalObject.url+'ajax/forms.php?action='+action,
		dataType: 'json',
		processData: false,
		contentType: false,
		success: function(response){
			//Determine if form was submitted successfully
			let banner = '';
			if(response.success) {
				//Success, determine message
				if(response.responses.success) {
					banner = '<div class="alertBanner success submission-result">'+response.responses.success+'</div>';
				} else {
					banner = '<div class="alertBanner success submission-result">Your submission has been received and we will contact you soon.</div>';
				}
			} else {
				if (response.validateZip === false && response.requireZip == 1){
					//Location error, determine message
					if(response.responses.locationError) {
						banner = '<div class="alertBanner alert submission-result">'+response.responses.locationError+'</div>';
					} else {
						banner = '<div class="alertBanner alert submission-result">It looks like you are outside our service area. We are only able to service customers who are local to us.<br><br> If you feel you received this message in error, please call our location closest to you. <a href="'+globalObject.url+'locations">Go to Locations</a></div>';
					}
				} else {
					if(response.responses.error) {
						if(response.uploadError) {
							let uploadErrorMessage = 'There was an error with your uploaded file(s).'
							switch(response.uploadError) {
								case 'type':
								case 'extension':
									uploadErrorMessage = 'You have uploaded an invalid file type.'
								break;
								case 'size':
									uploadErrorMessage = 'File size exceeds maximum limit.'
								break;
								case 'count':
									uploadErrorMessage = 'File count exceeds maximum limit.'
								break;
							}
							banner = `<div class="alertBanner alert submission-result">${uploadErrorMessage}</div>`;
						} else {
							banner = '<div class="alertBanner alert submission-result">'+response.responses.error+'</div>';
						}
					} else {
						banner = '<div class="alertBanner alert submission-result">An error has occurred while attempting to process your request. Please try again.</div>';
					}
				}
			}
			//Display alert banner
			isRecaptcha ? $(form).append(banner) : form.append(banner);
		}
	})
	.fail(function(jqXHR, textStatus, errorThrown) {
		console.log(jqXHR.responseText);
		console.log(textStatus);
		console.log(errorThrown);
	});
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
		}
    return false;
}

// TODO: Remove Jquery
$(document).ready(function () {
	SignupForm.init();

	$("input, textarea, select, option").blur(function () {
		_validateFormElement($(this));
	});

	$('form .contact-button, .contact-button[form=customForm]').click(function(e){
		var thisForm = $(this.form);
		if (_validateForm(thisForm)){
			let recaptcha = thisForm.find('.g-recaptcha');
			if (recaptcha.length){
				grecaptcha.execute(recaptcha[0].dataset.recaptchaId);
			} else {
				submitForm(1, thisForm, false);
			}
		} else {
			return false;
		}
	});

	var buttonActivated = false;
	// $('form .createAccountButton').click(function(e){
	// 	if(!buttonActivated){
	// 		e.preventDefault();
	// 	} else {
	// 		var thisForm = $(this.form);
	// 		if (_validateForm(thisForm)){
	// 			let recaptcha = thisForm.find('.g-recaptcha');
	// 			if (recaptcha.length){
	// 				grecaptcha.execute(recaptcha[0].dataset.recaptchaId);
	// 			} else {
	// 				submitForm(1, thisForm, false);
	// 			}
	// 		} else {
	// 			return false;
	// 		}
	// 	}
	// 	buttonActivated = true;
	// });
	$('input, select, textarea, option').focus(function(){
        if ($(this.form).find('.g-recaptcha').length) {
            $('.grecaptcha-badge').stop().animate({marginLeft: '0px'});
        }
	});
	$("input, select, textarea, option").blur(function(){
        if ($(this.form).find('.g-recaptcha').length) {
            $('.grecaptcha-badge').stop().animate({marginLeft: '0px'});
        }
    });
    
    //Phone input formatting
	$('input#phone, input#billPhone, #inputPhone input, input#phone_input').on('keydown', function(e) {
		if (!(/[\d|(|)|-]/.test(e.key)) && ($.inArray(e.keyCode, [37,38,39,40,45,46,8, 9,32]) == -1)) {
		  e.preventDefault();
		}
	});
	$('input#phone, input#billPhone, #inputPhone input, input#phone_input').on("keyup", function (e) {
		if ($.inArray(e.keyCode, [8,46]) == -1) {
			let phone = $(this).val();
			if (/^[0-9]{10}$/.test(phone)) {
				$(this).val('(' + phone.slice(0, 3) + ') ' + phone.slice(3, 6) + '-' + phone.slice(6, 10));
			} else if (/^[0-9]{11}$/.test(phone)) {
				$(this).val('(' + phone.slice(1, 4) + ') ' + phone.slice(4, 7) + '-' + phone.slice(7, 11));
			} else if (phone.length === 3 && /\d{3}/.test(phone)) {
				$(this).val('(' + phone + ') ');
			} else if (phone.length = 8 && /\(\d{3}\)\d{3}/.test(phone)) {
				$(this).val(phone.slice(0, 4) + ') ' + phone.slice(5, 8) + "-");
			} else if (phone.length === 9 && /\(\d{3}\)\s{1}\d{3}/.test(phone)) {
				$(this).val(phone + '-');
			} else if (phone.length === 13 && /\(\d{3}\)\s{1}\d{7}/.test(phone)) {
				$(this).val(phone.slice(0, 9) + '-' + phone.slice(9, 13));
			}
		}
	});
		
	//Review rating stars
	const ratingStars = {
		init: function(){
			form = $('form[name=writeAReview]'),
			reviewRating = form.find('input[name=reviewRating]'),
			stars = form.find('ul.star-ratings');
			this.handleEvents();
		},
		handleEvents: function(){
			//Hover to colorize stars
			stars.find('li').hover(function(i, el){
				let starRating = ratingStars.colorize($(this).data('star'));
				//Click to set hidden input
				form.find('.svg-icon').click(function(){
					reviewRating.val(starRating);
				});
			});
			//Check if still hovering on stars
			stars.hover(function(i, el){
				//Do nothing
			}, function(){
				//Remove active class
				//ratingStars.form.find('ul.star-ratings li i').removeClass('active');
				ratingStars.colorize(reviewRating.val());
			});
		},
		colorize: function(index){
			let counter = 1,
			rating = 0;
			stars.find('li').each(function(i){
				if (index >= counter) {
					$(this).find('.svg-icon').addClass("active");
					rating++;
				} else {
					$(this).find('.svg-icon').removeClass("active");
				}
				counter++;
			});
			return rating;
		},
	};
	ratingStars.init();
});

